<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                    <div>
                        <el-button type="warning" @click="exportList">导出
                        </el-button>
                    </div>
                </div>
            </div>

            <el-table :data="residentList" header-row-class-name="table-header" row-class-name="table-row" alig="center"
                border style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="操作人" prop="name"></el-table-column>
                <el-table-column label="商品名称" prop="product_name"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="内容" prop="desc"></el-table-column>
                <el-table-column label="时间" prop="create_time"></el-table-column>
            </el-table>
            <el-pagination v-if="residentList.length > 0" class="page-all" background @current-change="getResidentList"
                :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { exportProductLog, productLog } from "@/api/weilao";

export default {
    name: "shopping-caozuo",
    components: {},
    data() {
        return {
            id: '',
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/shopping', "双暖为老 / 商城管理 / 操作记录", true);
        this.id = this.$route.query.id
        this.getResidentList()
    },
    methods: {
        //  获取商品列表
        async getResidentList() {
            let _data = await productLog(
                this.id,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        async exportList() {
            let _state = await exportProductLog(this.id)
            let blob = _state.data
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.setAttribute('download', '操作记录.xls');
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
